import React from 'react';
import PropTypes from 'prop-types';

const ButtonSection = ({
  label,
  content,
  active,
  download,
  deviceQuantity,
  onToggle,
  onRedirect,
}) => (
  <div className="col-md-3 col-xs-12">
    <div className="row">
      {!active && (
        <div className="col-md-offset-6 col-md-6 col-xs-12">
          <button
            type="button"
            onClick={() => onRedirect(content, 'Renovar')}
            className="btn btn-primary btn-block margin-top-05 col-xs-12"
          >
            {label.btnRenew}
          </button>
        </div>
      )}
      {active && (
        <div
          className={`${
            download ? '' : 'col-md-offset-7 col-xs-offset-6'
          } col-md-5 col-xs-6`}
        >
          <button
            type="button"
            onClick={() => onRedirect(content, 'Ver')}
            className="btn btn-primary btn-block margin-top-05 col-xs-12"
          >
            {label.btnView}
            <i className="fa fa-play" style={{ paddingLeft: '16px' }} />
          </button>
        </div>
      )}
      {active && download && (
        <div className="col-lg-7 col-md-7 col-sm-6 col-xs-6">
          <button
            type="button"
            className="btn btn-default btn-block margin-top-05 col-xs-12"
            onClick={() => onRedirect(content, 'Descargar')}
          >
            {label.btnDownload}
            <i className="fa fa-download" style={{ paddingLeft: '16px' }} />
          </button>
        </div>
      )}
    </div>
    <div className="row">
      <div className="col-md-12 col-xs-12">
        <button
          type="button"
          className="btn btn-info margin-top-05 col-xs-12"
          onClick={() => onToggle(content)}
        >
          {label.btnDevices}
          <span
            style={{ right: '-5px' }}
            className="badge dispositivos-cantidad"
          >
            {deviceQuantity}
          </span>
        </button>
      </div>
    </div>
  </div>
);

ButtonSection.propTypes = {
  active: PropTypes.bool,
  download: PropTypes.bool,
  label: PropTypes.object,
  content: PropTypes.object,
  deviceQuantity: PropTypes.number,
  onToggle: PropTypes.func,
  onRedirect: PropTypes.func,
};

export default ButtonSection;
